// confirm.tsx
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { createRoot } from 'react-dom/client';
import { useState } from 'react';

interface ConfirmOptions {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
}

export function confirm(options: ConfirmOptions) {
  const { title, description, confirmText = '确认', cancelText = '取消' } = options;

  const div = document.createElement('div');
  document.body.appendChild(div);

  return new Promise<boolean>(resolve => {
    const root = createRoot(div);

    const ConfirmDialog = () => {
      const [open, setOpen] = useState(true);

      const close = (result: boolean) => {
        setOpen(false);
        resolve(result);
      };

      return (
        <AlertDialog
          open={open}
          onOpenChange={v => {
            if (!v) close(false);
          }}
        >
          <AlertDialogContent className="max-h-[80vh] max-w-4xl overflow-hidden bg-white">
            <AlertDialogHeader>
              <AlertDialogTitle>{title}</AlertDialogTitle>
              {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
            </AlertDialogHeader>

            <AlertDialogFooter>
              <AlertDialogCancel onClick={() => close(false)}>{cancelText}</AlertDialogCancel>

              <AlertDialogAction onClick={() => close(true)}>{confirmText}</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      );
    };

    root.render(<ConfirmDialog />);
  }).finally(() => {
    // 清理 DOM
    setTimeout(() => {
      div.remove();
    }, 300);
  });
}
